import React from 'react';
import { useTranslation } from 'react-i18next';

const SALUTATIONS = { MR: 'Herr', MRS: 'Frau' };

export default function Greeting({ customer, selecting }) {
  const { t } = useTranslation();
  if (!customer) return null;
  const salutation = customer.salutation ? t(`checkout.salutation.${customer.salutation}`, SALUTATIONS[customer.salutation]) : '';
  const name = [salutation, customer.family_name].filter(Boolean).join(' ');
  return (
    <div className="mb-3 text-sm md:text-base text-gray-800" data-testid="greeting">
      <p className="font-medium">{`${t('checkout.greeting', 'Guten Tag')} ${name},`}</p>
      {selecting && (
        <p>
          {t(
            'checkout.greeting.select',
            'bitte wählen Sie hier aus, wie Sie die Zuzahlung für Ihre neuen Hörgeräte bezahlen möchten.'
          )}
        </p>
      )}
    </div>
  );
}
